import type { JSX } from 'react';
import { useState } from 'react';
import { VerificationList } from '@/features/verifications/components/VerificationList';
import { VerificationFormDialog } from '@/features/verifications/components/VerificationFormDialog';
import { ConfirmDialog } from '@/features/candidates/components/ConfirmDialog';
import { useVerifications } from '@/features/verifications/hooks/useVerifications';
import { useVerificationDelete } from '../hooks/useVerificationDelete';

interface ExperienceVerificationsSectionProps {
  candidateId: string;
  experienceId: string;
}

export function ExperienceVerificationsSection({
  candidateId,
  experienceId,
}: ExperienceVerificationsSectionProps): JSX.Element {
  const [isAddDialogOpen, setIsAddDialogOpen] = useState(false);
  const { verifications, hasData, isLoading, isError } = useVerifications({
    candidateId,
    experienceId,
  });
  const { deletingId, setDeletingId, confirmDelete } = useVerificationDelete(
    candidateId,
    experienceId
  );

  return (
    <div className="p-4 bg-muted/50 border-t">
      <h4 className="text-sm font-semibold mb-3">Verifications</h4>
      <VerificationList
        verifications={verifications}
        hasData={hasData}
        isLoading={isLoading}
        isError={isError}
        onDelete={setDeletingId}
        onAdd={() => setIsAddDialogOpen(true)}
        candidateId={candidateId}
        experienceId={experienceId}
      />
      <VerificationFormDialog
        open={isAddDialogOpen}
        onOpenChange={setIsAddDialogOpen}
        candidateId={candidateId}
        experienceId={experienceId}
      />
      <ConfirmDialog
        open={!!deletingId}
        onOpenChange={(open) => !open && setDeletingId(null)}
        onConfirm={confirmDelete}
        title="Delete Verification"
        description="Are you sure you want to delete this verification? This action cannot be undone."
        confirmLabel="Delete"
        variant="destructive"
      />
    </div>
  );
}
